<template>
  <div
    class="petition-toast flex w-full items-start gap-3 rounded-xl border border-blue-light bg-white px-2 py-2 text-sm lg:rounded-2xl lg:px-6 lg:py-4 lg:text-base"
  >
    <span class="text-xl text-pink"><Heart class="h-6 w-6" /></span>
    <div>
      <p class="leading-snug text-black">
        {{ message }}
        <NuxtLink :to="link" class="text-pink underline">
          {{ linkText }}
        </NuxtLink>
        {{ suffix }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import Heart from '../atoms/Icons/Heart.vue'

defineProps<{
  message: string
  link: string
  linkText: string
  suffix?: string
}>()
</script>
